/* Khối dùng chung cho Start / Overview / Schedule / Awards (chỉ khu vực này). */
import { useState, type ReactNode } from "react"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { Button } from "@/components/ui/button"
import { Icon } from "@/components/icon"
import { cn } from "@/lib/utils"

/** Thay cho <details> cũ: một thẻ gấp/mở nhẹ nhàng. */
export function QuietDetails({ summary, children, defaultOpen = false }: { summary: ReactNode; children: ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="rounded-[20px] border-[1.5px] border-edge bg-card shadow-card">
      <CollapsibleTrigger className="flex w-full items-center justify-between gap-3 rounded-[20px] px-5 py-4 text-left font-heading text-base font-semibold text-ink transition-colors hover:text-orange-strong">
        {summary}
        <Icon name="chevron-down" className={cn("size-4 transition-transform", open && "rotate-180")} />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="flex flex-col gap-3 px-5 pb-5 text-sm text-muted-foreground">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  )
}

/** Lịch cố định + hình thức học của lớp. */
export function ClassMeta({ course }: { course: any }) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-x-6">
      <span className="flex items-center gap-2 text-ink">
        <Icon name="calendar" className="size-4 text-orange" />
        {course.schedule || "Lịch sẽ được cập nhật"}
      </span>
      <span className="flex items-center gap-2 text-ink">
        <Icon name="map-pin" className="size-4 text-orange" />
        {course.mode === "online" ? "Học online" : course.location || course.mode}
      </span>
    </div>
  )
}

export function ZoomButton({ session, course, className }: { session: any; course: any; className?: string }) {
  const url = session?.meeting_url || course?.meeting_url
  if (!url)
    return (
      <Button disabled variant="outline" className={className}>
        <Icon name="play-circle" /> Chưa có link Zoom
      </Button>
    )
  return (
    <Button nativeButton={false} className={className} render={<a href={url} target="_blank" rel="noreferrer" />}>
      <Icon name="play-circle" /> Vào Zoom
    </Button>
  )
}
